const DROP_DOWN_URL = "picklist";
const COMPANY_LIST = "company";
const apiUrl = { DROP_DOWN_URL, COMPANY_LIST };

export default apiUrl;
